import api from './client';

export interface PickupPref {
  pickup_id: number;
  is_default: boolean;
  usage_count: number;
  last_used_at: string | null;
}

export const fetchPickupPrefs = (region: string) =>
  api
    .get<{ prefs: PickupPref[] }>('/users/me/pickup-prefs', { params: { region } })
    .then((r) => r.data.prefs);

export const setDefaultPickup = (region: string, pickupId: number | null) =>
  api
    .put('/users/me/pickup-prefs/default', { region, pickup_id: pickupId })
    .then((r) => r.data);
